import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'
import { DragSource } from 'react-dnd'
import { FormattedMessage } from 'react-intl'
import { fileSize, getIconName } from 'utils/documents'
import Icon from 'components/Icon'
import {
  ListItem
} from 'components/List'
import RelativeDate from 'components/RelativeDate'
import classes from './Document.module.scss'
import BusyOverlay from 'components/BusyOverlay'

export const dragType = 'DOCUMENT'

export class Document extends React.Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,

    name: PropTypes.string.isRequired,
    lastModificationTimestamp: PropTypes.number,
    documentCount: PropTypes.number,
    objectType: PropTypes.number,
    size: PropTypes.number,
    draggable: PropTypes.bool,
    selectable: PropTypes.bool,
    selected: PropTypes.bool,
    listItem: PropTypes.bool,
    subtitle: PropTypes.object,
    thumbnailUrl: PropTypes.string,
    noAccess: PropTypes.bool,

    isBusy: PropTypes.bool,
    menu: PropTypes.array,
    showMenu: PropTypes.bool,
    onMenuToggle: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    onClick: PropTypes.func,
    onSelect: PropTypes.func,
    onDragStart: PropTypes.func,
  }

  state = {
    previewImage: null
  }

  componentDidMount = () => {
    this.fetchThumbnail()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.thumbnailUrl !== prevProps.thumbnailUrl) {
      this.cancelFetchThumbnail()
      this.fetchThumbnail()
    }
  }

  componentWillUnmount = () => {
    this.cancelFetchThumbnail()
  }

  fetchThumbnail = () => {
    const {
      thumbnailUrl
    } = this.props

    if (thumbnailUrl) {
      this.image = document.createElement('img')
      this.image.onload = this.handleImageLoad
      this.image.onerror = this.handleImageError
      this.image.src = thumbnailUrl
    } else {
      this.handleImageError()
    }
  }

  cancelFetchThumbnail = () => {
    if (this.image) {
      this.image.onload = null
      this.image.onerror = null

      delete this.image
    }
  }

  handleImageLoad = () => {
    this.setState({
      previewImage: true
    })
  }

  handleImageError = () => {
    this.setState({
      previewImage: false
    })
  }

  renderName = () => {
    const { name, noAccess } = this.props

    return noAccess ? (
      <span className='text-danger'>
        <FormattedMessage id='DOCUMENTS_SOURCE_ACCESS_DENIED' />
      </span>
    ) : name
  }

  render () {
    const {
      connectDragSource,

      name,
      lastModificationTimestamp,
      documentCount,
      objectType,
      size,
      draggable,
      selectable,
      selected,
      listItem,
      subtitle,
      thumbnailUrl,

      isBusy,
      menu,
      showMenu,
      onMenuToggle,
      className,
      style,
      onClick,
      onSelect,
    } = this.props
    const {
      previewImage
    } = this.state

    const isFolder = objectType === 1

    const iconName = getIconName(name, isFolder)

    if (listItem) {
      let compSubtitle = subtitle

      compSubtitle = (
        <span>
          {lastModificationTimestamp && <RelativeDate pastOnly timestamp={lastModificationTimestamp} />}
          {(!isFolder && typeof size === 'number') &&
            <React.Fragment>
              {lastModificationTimestamp && <span className={classes.subtitleDivider}>•</span>}
              {fileSize(size)}
            </React.Fragment>
          }
          {typeof documentCount === 'number' &&
            <React.Fragment>
              <span className={classes.subtitleDivider}>•</span>
              <FormattedMessage
                id='DOCUMENT_FOLDER_COUNT'
                values={{
                  count: documentCount.toString()
                }}
              />
            </React.Fragment>
          }
          {subtitle &&
            <React.Fragment>
              <span className={classes.subtitleDivider}>•</span>
              {subtitle}
            </React.Fragment>
          }
        </span>
      )

      let icon = null

      if (previewImage) {
        // Image preview
        icon = (
          <div className={classes.previewContainer}>
            <img
              className={classes.previewImage}
              src={thumbnailUrl}
              alt=''
            />
          </div>
        )
      } else {
        icon = (
          <Icon
            className={classes.icon}
            fixedWidth
            name={iconName}
          />
        )
      }

      return (
        <ListItem
          ref={ref => {
            const node = findDOMNode(ref)
            connectDragSource(draggable ? node : null)
          }}
          style={style}
          className={className}
          icon={icon}
          subtitle={compSubtitle}
          dragType={dragType}
          draggable={draggable}
          selectable={selectable}
          selected={selected}
          menu={menu}
          showMenu={showMenu}
          onMenuToggle={onMenuToggle}
          onClick={onClick}
          onSelect={onSelect}
        >
          {isBusy && <BusyOverlay />}
          {this.renderName()}
        </ListItem>
      )
    } else {
      return (
        <span
          style={style}
          className={className}
          onClick={onClick}
        >
          <Icon fixedWidth name={iconName} />
          {' '}
          {this.renderName()}
        </span>
      )
    }
  }
}

const dragSource = {
  beginDrag (props) {
    const draggedItem = {
      url: props.url,
      documentSourceId: props.documentSourceId
    }

    if (props.onDragStart) props.onDragStart(draggedItem)

    return draggedItem
  }
}

export default DragSource(dragType, dragSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview()
}))(Document)
